export default __webpack_public_path__ + "static/media/playerReportActive.8be40a0c.svg";